module.exports = __webpack_public_path__ + "img/chart_widget.bec36e7.svg";